import { render, staticRenderFns } from "./AbortoProcesso.vue?vue&type=template&id=0930e14f&scoped=true&"
import script from "./AbortoProcesso.vue?vue&type=script&lang=js&"
export * from "./AbortoProcesso.vue?vue&type=script&lang=js&"
import style0 from "./AbortoProcesso.vue?vue&type=style&index=0&id=0930e14f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0930e14f",
  null
  
)

export default component.exports